/*
 * Copyright (c) 2026 Macrofocus GmbH. All Rights Reserved.
 */
package org.mkui.component.input

import com.macrofocus.common.properties.MutableProperty
import js.objects.unsafeJso
import org.mkui.color.MkColor
import org.mkui.component.CPComponent
import org.mkui.react.useProperty
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.useState
import web.cssom.Border
import web.cssom.Color
import web.cssom.None
import web.cssom.pct
import web.cssom.pt
import web.cssom.px

actual class CPTextField actual constructor(private val textProperty: MutableProperty<String>) : CPComponent {
    actual var text by textProperty

    actual var isEditable: Boolean = true

    actual var fontSize: Float = 12f

    actual var foreground: MkColor? = null

    private var commitListener: ((String) -> Unit)? = null

    override val nativeComponent: FC<*> = FC<Props> {
        val (text, _) = useProperty(textProperty)
        // The edited text, null while not edited
        var draft by useState<String?>(null)

        fun commit(value: String) {
            if (value != text) {
                commitListener?.invoke(value)
            }
            // Rejected or unchanged edits show the text again
            draft = null
        }

        ReactHTML.input {
            value = draft ?: text
            readOnly = !isEditable
            style = unsafeJso {
                width = 100.pct
                height = 100.pct
                padding = 0.px
                border = None.none.unsafeCast<Border>()
                background = None.none.unsafeCast<Color>()
                fontSize = this@CPTextField.fontSize.toDouble().pt
                foreground?.let { color = Color(it.color) }
            }
            onChange = { draft = it.target.value }
            onBlur = { event -> draft?.let { commit(it) } }
            onKeyDown = { event ->
                when (event.key) {
                    "Enter" -> commit(draft ?: text)
                    "Escape" -> draft = null
                }
            }
        }
    }

    actual fun setCommitListener(listener: ((String) -> Unit)?) {
        commitListener = listener
    }
}
